import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { fetchDistrick, fetchConstituency } from "../../../api";
import Select from "react-select";
import { Link } from "@quintype/components";
import Icon from "../../atoms/icon";
import styles from "../constituency-searchbar/styles.m.css";

class AutoSelectComponent extends React.Component {
  logChange = val => {
    const { SelectedValue } = this.props;
    SelectedValue(val.value);
  };

  render() {
    const { options, className } = this.props;
    return <Select className={styles[className]} options={options} onChange={this.logChange} />;
  }
}

AutoSelectComponent.propTypes = {
  options: PropTypes.array,
  SelectedValue: PropTypes.func,
  className: PropTypes.string
};

const ConstituencyDirectSearch = () => {
  const [districk, setDistrick] = useState([]);
  const [constituency, setConstituency] = useState([]);
  const [selectedDistrick, setSelectedDistrick] = useState("");
  const [selectedConstituency, setSelectedConstituency] = useState(null);

  useEffect(() => {
    fetchDistrick()
      .then(res => {
        const disRes = get(res, ["data", "items"]);
        setDistrick(disRes);
      })
      .catch(console.error);

    fetchConstituency()
      .then(res => {
        const conRes = get(res, ["data", "items"]);
        setConstituency(conRes);
      })
      .catch(console.error);
  }, []);

  const disOp =
    districk &&
    districk.map(item => {
      const objItem = {};
      objItem.label = `${item.District_Tm} (${item.District_En})`;
      objItem.value = item.Id;
      return objItem;
    });

  const contOp =
    constituency &&
    constituency.filter(i => selectedDistrick === i.thokkuthi_district).map(item => {
      const objItem = {};
      objItem.label = `${item.area}`;
      objItem.value = item.thokkuthi_slug;
      return objItem;
    });

  // Build base href
  let href = "#";
  if (selectedConstituency) {
    href = `/election/tn-assembly-election-2026/constituency/${selectedConstituency}`;

    if (typeof global !== "undefined" && global.location) {
      const regExp = /source=app/;
      if (regExp.test(global.location.href)) {
        // If the URL already has a query string, append with "&"
        href += href.includes("?") ? "&source=app" : "?source=app";
      }
    }
  }

  return (
    <div className={styles["search-form-wrapper"]}>
      <div>
        <label>மாவட்டம்</label>
        <AutoSelectComponent className="districk" options={disOp} SelectedValue={e => setSelectedDistrick(e)} />
      </div>
      <div>
        <label>சட்டமன்றத் தொகுதி</label>
        <AutoSelectComponent className="districk" options={contOp} SelectedValue={e => setSelectedConstituency(e)} />
      </div>
      <Link
        aria-label="இங்கு க்ளிக் செய்க"
        className={selectedConstituency ? styles["submit-btn"] : styles["isDisabled"]}
        href={href} // ✅ pass the computed href here
      >
        இங்கு க்ளிக் செய்க <Icon type="double-arrow" className={styles["arrow-right"]} />
      </Link>
    </div>
  );
};

export default ConstituencyDirectSearch;
